import type { ElementType } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { DropdownThreeDotsIcon } from '@hivebrite/design-system/Dropdown';

interface DropdownButtonProps {
  title: string;
  items: {
    label: string;
    icon: ElementType;
    dataTestId?: string;
    onClick: () => void;
  }[];
}

const DropdownButton = ({ items, title }: DropdownButtonProps) => (
  <Box display="block">
    <DropdownThreeDotsIcon
      dataTestId="dropdown-forum-discussion"
      items={items}
      title={s__(
        'ForumAccessibility|Action dropdown to discussion %{title}',
      ).i__({
        title,
      })}
    />
  </Box>
);

export default DropdownButton;
